import {computed} from "@preact/signals-core";
import {s_char} from "./s_char";
import {modSum} from "./s_char_calc";

const s_char_kv = computed(() => {
    return s_char.value.kv + modSum(s_char.value.id,'kv')
});
const s_char_mv = computed(() => {
    return s_char.value.mv + modSum(s_char.value.id,'mv');
});
const s_char_sv = computed(() => {
    return s_char.value.sv + modSum(s_char.value.id,'sv')
});

export {s_char_kv, s_char_mv, s_char_sv}
